import {NgModule} from '@angular/core';
import {CounterComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf
  ],
  exports: [
    CounterComponent
  ],
  declarations: [CounterComponent],
  providers: [],
})
export class CounterComponentModule {
}
